import ResponsiveImage from "../../atoms/image/ResponsiveImage";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

// https://share.anysnap.app/fJjhVeNqDyRS
const ReviewCard = ({ data, isNewDesign }) => {
  return (
    <>
      <li className="review-card">
        <div className="review-from">{data.from}</div>
        {Array.isArray(data.text) ? (
          data.text.map((item, index) => {
            return (
              <p
                key={index}
                dangerouslySetInnerHTML={{ __html: item }}
                className="mt-2"
              />
            );
          })
        ) : (
          <p dangerouslySetInnerHTML={{ __html: data.text }} />
        )}
        <cite>―{data.name}</cite>
      </li>
      <style jsx>{`
        ${isNewDesign
          ? `
        .review-card .review-from {
          font-size: ${font.size.md[2]} !important;
          line-height: ${lineHeight[7]} !important;
          font-weight: ${font.weight.bold};
          }
        cite {
          color: ${colors.primitive.grey[300]};
        }`
          : ``}
      `}</style>
    </>
  );
};

const ProductCard = ({ data }) => {
  return (
    <>
      <li className="product-card">
        <i dangerouslySetInnerHTML={{ __html: data.icon }}></i>
        <p
          dangerouslySetInnerHTML={{ __html: data.text }}
          className="mt-4 mb-2"
        />
        <a href={data.href} className="text-brandcolor">
          {data.hrefText}
        </a>
      </li>
      <style jsx>
        {`
          .product-card {
            background-color: ${colors.primitive.blue[30]};
            border: 4px solid ${colors.primitive.white.default};
            padding: 40px 24px 32px;
          }
          .product-card p {
            color: ${colors.primitive.black[900]};
          }
          .product-card a {
            font-size: ${font.size.md[1]};
            text-decoration: none;
          }
        `}
      </style>
    </>
  );
};

// https://share.anysnap.app/fYgbP8QA9NnH
const RatingCard = ({ data }) => {
  return (
    <li className="rating-card">
      <i dangerouslySetInnerHTML={{ __html: data.icon }}></i>
      <p>
        <strong>{data.rating}</strong>{" "}
        <span dangerouslySetInnerHTML={{ __html: data.text }}></span>
      </p>
    </li>
  );
};

// https://share.anysnap.app/feU0rocAHGvz
const BadgingCard = ({ data }) => {
  return (
    <li className="review-card fx lg:px-2 lg:py-2 md:py-2">
      <div className="card--default md:fx">
        <figure>
          <img loading="lazy" src={data.image.src} alt={data.image.alt} />
        </figure>
        <div className="lg:ml-2 lg:mt-2 md:mt-1.5">
          <p className="review-from fw-600">{data.name}</p>
          <p className="text-smx">{data.category}</p>
        </div>
      </div>
    </li>
  );
};

// https://share.anysnap.app/f8ZXmLIlcfEp
const PeopleCard = ({ data, bg, imgClasses }) => {
  return (
    <li
      className={`client-card boxshadow-none bg-${bg} ${
        data.hasPadding ? `` : `lg:px-0 lg:py-0 md:px-0 `
      }`}
    >
      <figure>
        <figcaption
          className={`lg:d-fx md:d-fx ${
            data.hasPadding ? `` : `lg:pt-3 lg:px-3 md:px-3`
          }`}
        >
          <span
            className={`quot-glyph lg:mt-0 md:mt-0 ${
              bg === "grey" ? `text-grey` : ``
            }`}
          >
            “
          </span>
          <p
            className={`text-md mb-2 ${bg === "grey" ? `text-grey` : ``}`}
            dangerouslySetInnerHTML={{ __html: data.text }}
          ></p>
        </figcaption>
        <ResponsiveImage
          src={data.image.src}
          alt={data.image.alt}
          dpi={data.image.prefixes.dpi}
          mobile={data.image.prefixes.mobile}
          width={data.image.dimensions[0]}
          height={data.image.dimensions[1]}
          imgClass={`img-fit`}
          hasMobileImg={false}
        />
      </figure>
      <style jsx>{`
        :global(.text-underline) {
          text-decoration: underline;
        }
        .bg-purple {
          background-color: ${colors.primitive.violet[200]};
        }
        .bg-yellow {
          background-color: ${colors.primitive.yellow.default};
        }
        .bg-grey {
          background-color: ${colors.primitive.black[300]};
        }
        .bg-red {
          background-color: ${colors.primitive.red[200]};
        }
        .bg-blue {
          background-color: ${colors.derived.brand};
        }
        .bg-orange {
          background-color: ${colors.primitive.red[300]};
        }
      `}</style>
    </li>
  );
};

// https://share.anysnap.app/f8q82s3mZ5JO
const StatsCard = ({ data }) => {
  return (
    <li className={`stats-card ${data.colorScheme}`}>
      {data.hasOwnProperty("number") && <strong>{data.number}</strong>}
      {Array.isArray(data.text) ? (
        data.text.map((item, index) => {
          return (
            <p
              key={index}
              dangerouslySetInnerHTML={{ __html: item }}
              className={`${data.number ? "mt-1" : ""}`}
            />
          );
        })
      ) : (
        <p dangerouslySetInnerHTML={{ __html: data.text }} />
      )}
      {data.name && <cite dangerouslySetInnerHTML={{ __html: data.name }} />}
      <style jsx>{`
        .stats-card.green {
          background-color: ${colors.primitive.green[500]} !important;
        }
        .stats-card.green * {
          color: ${colors.primitive.green[400]} !important;
        }
        .stats-card.violet {
          background-color: ${colors.primitive.violet[400]} !important;
        }
        .stats-card.violet * {
          color: ${colors.primitive.violet[300]} !important;
        }

        .stats-card.yellow {
          background-color: ${colors.primitive.yellow[200]};
        }
        .stats-card.yellow * {
          color: ${colors.primitive.yellow.default};
        }
        .stats-card.blue {
          background-color: ${colors.primitive.blue[30]};
        }
        .stats-card.blue * {
          color: ${colors.primitive.blue[50]};
        }
        .stats-card.light-blue {
          background-color: ${colors.primitive.blue[400]};
        }
        .stats-card.light-blue * {
          color: ${colors.primitive.blue[500]};
        }
        .stats-card.orange {
          background-color: ${colors.primitive.orange[100]};
        }
        .stats-card.orange * {
          color: ${colors.primitive.red[300]};
        }
        ${data.hasOwnProperty("colorScheme")
          ? `
          .stats-card {
            box-shadow: 0 1px 2px 0 rgba(48, 58, 71, 0.2),
              0 1px 3px 0 rgba(48, 58, 71, 0.1) !important;
            border: solid 4px ${colors.primitive.white.default};
          }
          .stats-card strong {
            font-size: ${font.size.xl[2]} !important;
          }
        `
          : ``}
      `}</style>
    </li>
  );
};

const ListItem = ({ data, isNewDesign }) => {
  return data.map((item, index) => {
    if (item.hasOwnProperty("review")) {
      return (
        <ReviewCard key={index} data={item.review} isNewDesign={isNewDesign} />
      );
    }
    if (item.hasOwnProperty("rating")) {
      return <RatingCard key={index} data={item.rating} />;
    }
    if (item.hasOwnProperty("people")) {
      return (
        <PeopleCard key={index} data={item.people} bg={item.people.color} />
      );
    }
    if (item.hasOwnProperty("badge")) {
      return <BadgingCard key={index} data={item.badge} />;
    }
    if (item.hasOwnProperty("stats")) {
      return <StatsCard key={index} data={item.stats} />;
    }
    if (item.hasOwnProperty("productCard")) {
      return <ProductCard key={index} data={item.productCard} />;
    }
  });
};
export default function Masonry({ data, wrapClass = "", isNewDesign = false }) {
  return (
    <article className={`container card--default card--masonry ${wrapClass}`}>
      {data.map((item, index) => {
        return (
          <ul key={index}>
            <ListItem data={item} isNewDesign={isNewDesign} />
          </ul>
        );
      })}
      <style jsx>{`
        ${isNewDesign
          ? `
          .product-card {
            font-size: ${font.size.md[2]} !important;
            line-height: ${lineHeight[7]} !important;
            }
          @media (max-width: ${viewport.mobile.md}) {
            ul .rating-card, ul .review-card, ul .client-card, ul .stats-card {
              margin-bottom: 24px!important;
            }
          }
      `
          : ``}
      `}</style>
    </article>
  );
}
